import { fixMenu } from "./components/fixMenu";

const nameError = document.getElementsByClassName("input-container")[0];
const emailError = document.getElementsByClassName("input-container")[1];
const messageError = document.getElementsByClassName("input-container")[2];
nameError.insertAdjacentHTML('beforeend', `<p class="formulars__field_error-js" id="nameError-js"></p>`);
emailError.insertAdjacentHTML('beforeend', `<p class="formulars__field_error-js" id="emailError-js"></p>`);
messageError.insertAdjacentHTML('beforeend', `<p class="formulars__field_error-js" id="messageError-js"></p>`);

const navMenu = document.querySelector('nav');
navMenu.addEventListener("click", function() {
    fixMenu();
});